<template>
    <article class="doc-article">
		<p>本协议由用户（以下称“您”或“用户”）与北京动态时序科技有限公司（以下简称“动态时序”或我们）就动态时序官网（http://www.workatdata.com/，包括任何继承、重命名和任何子域名）提供的产品服务所订立的相关权利义务规范。您在注册为动态时序用户前，需仔细阅读并完全理解本协议内容及动态时序公布的其他服务规则（以下统称为“服务条款”），如果您不同意受该等服务条款的约束，应停止注册程序并停止使用动态时序服务。您通过网络页面点击确认或其他方式接受本协议，即视为您已认真阅读服务条款全部内容对服务条款均已知晓、理解并接受，同意将其作为确定双方权利义务的依据服务条款对您及动态时序均具有法律效力。</p>
		<p>如本协议约定的条款与用户和公司签订的线下协议有冲突之处，以线下协议为准；线下协议未约定的事项，以本协议及用户在动态时序点击同意的各项服务条款为准。</p>
		<h5>1.服务对象</h5>
		<p>1.1.同时满足下列条件的，方可被认定为动态时序用户：</p>
		<p>1.1.1.同意本协议内容并接受其约束；</p>
		<p>1.1.2.完成在动态时序的注册程序并获得动态时序账号和密码；</p>
		<p>1.2.动态时序用户类型及实名认证：</p>
		<p>1.2.1.动态时序用户类型：</p>
		<p>1）个人用户；</p>
		<p>2）单位用户（或称为“企业用户”）。</p>
		<p>1.2.2.实名认证说明：</p>
		<p>您理解并同意，为了您的账户和交易安全合规，动态时序有权要求用户完成动态时序账户的实名认证。如未进行企业认证，则无法使用部分产品提供的服务。</p>
		<p>1）单位用户进行实名认证需按照动态时序的要求提供包括但不限于个营业执照正副本照片、从事与动态时序合作业务或使用动态时序服务所必需的资质许可（如需）、企业基本信息以及动态时序认为为向用户提供满足用户需求的服务所必需的其他信息。另外，为了保护单位用户的交易安全，动态时序可能会根据情况要求单位用户以该单位开立的银行账户向动态时序进行对公转账（可转为产品预付款使用），以进一步确认单位的主体资质合法有效存续及获得了单位的充分授权。</p>
		<p>2）用户应保证其向动态时序提供的实名认证的证件、信息等内容真实、准确、完整、及时、有效、因用户提供的证件、信息等内容不满足真实、准确、完整、及时、有效条件而引起的各种损失或责任，均由用户自行承担。</p>
		<p>3）用户应保证如为企业实名制客户应保证用户注册及后续操作行为（包括但不限于注册、充值、购买、消费、申请退款等）均获得了被认证单位的有效授权，否则由此导致的各种损失或责任，均由用户自行承担。</p>
		<p>4）当企业实名用户在经营过程中丧失了企业主体资格，如发生企业注销、被吊销、被撤销等，则用户及时告知动态时序，并对实名认证信息进行变更或将相应账户注销；在用户未告知动态时序，但动态时序自行发现产生了前述情形时，动态时序有权驳回该账户的实名认证，并有权拒绝提供需要先实名认证才可使用的产品，同时因此产生的各类不利后果由用户自行承担。</p>
		<h5>2.服务内容</h5>
		<p>2.1.动态时序产品服务说明</p>
		<p>动态时序用户可以按照自身需求使用动态时序提供的各类API及其他技术产品，具体产品详情、资费标准及注意事项等详见产品详情页面。</p>
		<p>1）在您开始使用动态时序的某一产品或服务前，可能需要和动态时序就这一产品或服务签订单独的服务协议。您只有在接受该服务协议的全部内容后方可使用该服务协议的全部内容后方可使用该产品或服务。您使用动态时序的产品或服务需基于合法合规的业务需求。</p>
		<p>2）在您使用动态时序服务时，动态时序有权依照相应的产品及/或服务收费介绍、订单及/或相关协议向您收取服务费用。动态时序有权根据市场运作、服务内容、发展规划等因素调整相应产品服务收费标准，并于官网或相应的产品详情页进行公告，而无需单独通知用户。用户在购买相应的产品服务时，应关注最新服务收费标准。</p>
		<p>3）当您使用的产品需要预付费时，您应当关注账户余额是否充足，否则可能因为费用不足导致服务终止。当您因欠费而被终止服务后，您仍应将欠缴的费用付清。否则，动态时序将保留按照您未付费用的万分之五的标准，按日向您收取逾期付款违约金的权利。</p>
		<p>4）您理解并同意，动态时序提供的产品服务购买后仅限于申请账号自行使用、不能在动态时序账号之间转移。</p>
		<p>5）您理解并同意，针对API接口产品，如涉及信息主体非公开信息尤其是个人信息的，您应当：</p>
		<p>a)向动态时序提供真实合法的应用场景（“应用场景”指应用所有权人拥有自主知识产权的应用，包括网站、客户端软件、移动互联网应用程序、公众号、软件系统等互联网产品项目），并遵循个人信息的最小必要原则。</p>
		<p>b)获得信息主体尤其是个人对的合法有效充分授权，并作出足以引起信息主体注意的提示。</p>
		<p>c)配合我们提供有关数据服务应用场景、授权协议文本（例如有效的隐私政策）、系统操作日志等相关证明材料，同时配合我们进行有关双方数据服务合作事项的监督管理。</p>
		<p>6）信息核验/查询类产品无法保证100%的准确率和及时性，或由于产品本身字段的局限性，其反馈/查询结果仅供您参考，您不应以核验/查询结果作为行为依旧或提供给他人作为行为依据。</p>
		<p>7）您理解并同意，您使用我们的产品或服务，不得违反本协议宗旨用于其他目的或转让给第三方使用，不得将接口产品所涉查询核验结果用于约定以外的应用场景或者再次分发、销售、许可、分许可、授权、转售、出租、租借、进出口、转授权或转让集成使用，也不得将接口产品以任何形式交由第三方使用。</p>
		<p>2.2.产品定制服务</p>
		    <p>如动态时序提供的标准服务无法满足用户需求，动态时序愿意为用户提供特殊定制服务。用户可联系动态时序客服咨询定制服务相关信息。</p>
		<p>2.3.第三方产品服务</p>
		<p>动态时序可能会与第三方合作向您提供产品，如果您使用到第三方提供的任何产品或服务，您还可能受限于该等第三方的相关条款和条件；由该第三方提供或服务导致的质量问题或任何纠纷、损失，动态时序对此不承担任何责任，本服务条款不影响您与该第三方的法律关系。</p>
		<h5>3.服务内容的变更、中断和结束</h5>
		<p>3.1.动态时序致力于为用户提供更优质更稳定的服务，因此动态时序可能会在服务期间对网站或产品进行优化升级。动态时序进行优化升级之前，将会在网站相应位置进行公告，请用户实时关注。因优化升级而暂时中断为用户提供服务，不视为动态时序违反服务条款，动态时序不因此向客户承担任何责任。</p>
		<p>3.2.动态时序将通过优化服务、技术升级等方式为用户提供优质、稳定、持续的服务，但因不可抗力因素导致的服务中断或影响服务质量，用户理解并豁免动态时序与此相关的任何责任。不可抗力因素包括但不限于自然灾害、罢工、骚乱、大规模流行性疾病、暴动、战争、政府行为、国家政策的突然变动、计算机病毒或黑客攻击、电信主干线路中断、网络堵塞等。</p>
		<p>3.3.若用户不再需要动态时序的服务，用户可通过发送邮件至service@workatdata.com到客服向动态时序发出账户注销申请（具体详见本协议下文关于“账户注销”的约定），经动态时序审核通过，双方终止协议关系，动态时序将停止为用户提供服务。</p>
		<p>3.4.用户在合作过程中需持续满足本协议约定的规则及动态时序规定的其他用户条件，若用户不再符合前述规则，动态时序有权依情形作出终止服务、注销或冻结用户的动态时序的账户等决定。用户如对此有任何异议，可向动态时序提出异议申请并配合提供相应证明材料，通过审核后可予以恢复使用。动态时序有权对用户是否违反协议约定以及违反程度是否严重作出独立判断并采取相应措施。</p>
		<p>3.5.动态时序有权根据自身运营情况随时调整产品或服务，或随时中止、终止相关产品服务，用户理解并豁免动态时序与此相关的任何责任。</p>
		<p>3.6.用户应持续遵守服务条款，若用户存在违反服务条款的情形，动态时序有权中断或终止服务，或者采取动态时序认为合理的其他措施。</p>
		<p>3.7.无论本服务条款因何原因中止或终止，在本服务条款中止或终止前的行为所导致的任何赔偿和责任，用户应完全且独立地承担责任。</p>
		<h5>4.用户账号管理及账号注销</h5>
		<p>4.1.账户管理</p>
		<p>4.1.1.您理解并同意，您注册成功动态时序账户后，您应自行做好已注册账户的操作权限管理和密码管理，所有对账户的操作视为基于您的真实意思表示，是您本人操作或者已经得到您的有效授权。除非有法律规定或生效法律文书确定，或者符合动态时序公布的条件，否则您不得以任何方式转让、赠与或让他人继承您的动态时序账户。同时，在进行符合条件的动态时序账户转让、赠与或继承时，动态时序有权要求您、及/或受让受赠者，或您的继承人提供合格的文件材料并按照动态时序要求的操作流程办理。</p>
		<p>4.1.2.在通常情况下，同一用户在动态时序官网拥有一个账户。但若您在动态时序同时拥有2个以上账户，动态时序建议您将停止使用的账户予以注销；同时，多个账户属于同一法律主体的，若其中一个账户产生恶意欠费、违约、违法行为的，动态时序有权对该法律主体所有动态时序账户视为同一个整体，进行统一处理。</p>
		<p>4.1.3.当用户发现动态时序账号被未经授权的第三方使用或存在其他账号安全问题时应立即有效通知动态时序，要求动态时序暂停该动态时序账号的服务，并向公安机关报案。动态时序有权在合理时间内对用户的该等请求采取行动，配合用户作出相应处理措施，但对用户遭受的损失不承担任何责任。</p>
		<p>4.1.4.为维护用户合法权益，动态时序将采取有效措施保护用户的账户信息。若用户在使用动态时序账户时发现安全漏洞，请立即以有效方式通知动态时序。虽然动态时序将全力、持续完善账户维护技术手段，但受限于目前的技术水平，动态时序无法保证所采取的措施都是有效和安全无虞的，用户知晓、理解并豁免动态时序因此产生的责任。</p>
		<p>4.2.账户注销</p>
		<p>当您决定不再使用过我们的产品时，您可以通过联系客服申请注销账户。我们的客服会在15个工作日内完成核查处理。</p>
		<p>您理解并接受：</p>
		<p>4.2.1.您注销账户的行为会给您的售后维权带来诸多不便，一旦被注销即不可恢复。因此，我们会对您的注销申请进行必要的核查，包括：</p>
		<p>1）账户内没有未完成的订单或服务；</p>
		<p>2）账户内没有余额，如有余额您可以先申请退款，如不申请退款即申请注销，我们视为您放弃余额；</p>
		<p>3）账户内的虚拟权益包括但不限于免费赠送服务等均不可折现，您在注销时即表示自愿放弃；</p>
		<p>4）账户内没有欠款，如有欠款先足额支付；</p>
		<p>5）账户无任何纠纷争议，包括投诉举报、实名认证主体非本人等，我们认为有必要时，需要您提供主体资质信息，以确认您有权注销账户；</p>
		<p>6）近期内没有异常登录、更改实名认证信息等敏感操作；</p>
		<p>7）如果动态时序账户已与第三方账户绑定，您可能需要先解除绑定。</p>
		<p>4.2.2.您的账户注销后，我们会在系统中去除账户信息，使其保持不可被检索、访问的状态，或对其进行匿名化处理。但您知晓并接受，按照有关法律法规的规定，商品和服务信息、交易信息保存时间自交易完成之日起不少于三年；法律、行政法规另有规定的，依照其规定。</p>
		<h5>5.用户义务</h5>
		<p>5.1.不得利用动态时序提供的数据危害国家安全、泄漏国家秘密，不得侵犯国家社会集体的和公民的合法权益，不得利用动态时序提供的数据制作、复制和传播下列信息：</p>
		<p>1）煽动抗拒、破坏宪法和法律、行政法规实施的；</p>
		<p>2）煽动颠覆国家政权、推翻社会主义制度的；</p>
		<p>3）煽动分裂国家、破坏国家统一的；</p>
		<p>4）煽动民族仇恨、民族歧视、破坏民族团结的；</p>
		<p>5）捏造或者歪曲事实、散布谣言、扰乱社会秩序的；</p>
		<p>6）宣扬封建迷信、淫秽、色情、赌博、暴力、凶杀、恐怖、教唆犯罪的；</p>
		<p>7）公然侮辱他人或捏造事实诽谤他人的，或者进行其他恶意攻击的；</p>
		<p>8）损害国家机关信誉的；</p>
		<p>9）其他违反宪法和法律行政法规的。</p>
		<p>5.2.用户应当遵守法律法规、规章、规范性文件及政策要求的规定，不得利用动态时序产品服务从事非法或其他损害动态时序或第三方权益的活动，如有违反，产生的一切法律责任由其自身承担而与动态时序无关。如用户因此对动态时序造成的任何损害，用户应当赔偿一切损失。</p>
		<p>5.3.不得从事下列危害计算机信息网络安全的活动：</p>
		<p>1）未经允许，进入动态时序计算机信息网络或者使用计算机信息网络资源的；</p>
		<p>2）未经允许，对动态时序计算机信息网络功能进行删除、修改或者增加的；</p>
		<p>3）未经允许，对动态时序计算机网络中存储或者传输的数据和应用程序进行删除、修改或者增加的；</p>
		<p>4）故意制作、传播计算机病毒等破坏性程序，对动态时序造成影响的；</p>
		<p>5）利用动态时序产品非法获取公民个人信息；</p>
		<p>6）非法获取动态时序的商业秘密；</p>
		<p>7）破坏动态时序版权技术保护措施，或侵害动态时序的知识产权；</p>
		<p>8）其他危害计算机信息网络安全的行为。</p>
		<p>5.4.用户知悉、确认并保证，您使用动态时序产品服务所有资金来源合法，不得利用动态时序产品进行非法集资、洗钱、传销、非法吸收公众存款等违法犯罪活动。</p>
		<p>5.5.用户理解并接受，如用户违反上述5.1-5.4条任一条约定，均为根本违约；动态时序主动发现用户有上述情形或因第三人的投诉、有权机关的提示警告、重大负面舆论等途径发现后，有权对该情形性质进行判定，并采取相应措施（包括但不限于中止/终止服务）、追究用户的违约责任和损失赔偿责任。</p>
		<p>5.6.用户对其自身的应用产品，例如网站、APP、小程序等，严格按照国家相关的法律法规做好信息安全管理工作，健全各项网络安全管理制度和落实各项安全保护技术措施，保护数据信息安全。如发生重大安全事故时，应立即采取有效措施防止扩大损失，保留有关原始记录，并在24小时内向有关部门报告并书面告知动态时序。</p>
		<p>5.7.用户理解并接受有关数据跨境的法律法规，如涉及在中华人民共和国境内运营过程中收集和产生的个人信息和重要数据，应当在境内存储。因业务需要，确需向境外提供的，应当按照有关规定进行安全评估。如按照有关跪地你那个须经有关部门批准的，应当获取批准后才可向境外提供。个人信息出境，应向个人信息主体说明数据出境的目的、范围、内容、接收方及接收方所在的国家或地区，并经其同意。未成年人个人信息出境须经其监护人同意。</p>
		<p>5.8.动态时序的产品和服务主要面向合法存续的企业和完全民事行为能力人。当用户为企业或其他组织时，您确认已获得该组织的充分有效授权以代表其注册、使用动态时序服务并同意本协议；当用户为个人时，如不具备完全民事行为能力，则应在监护人的陪同下且征得监护人的明确同意后方能注册成为动态时序用户。</p>
		<h5>6.知识产权</h5>
		<p>6.1.对于动态时序提供的软件、接口、代码、开发工具或其他技术产品（“技术产品”），动态时序是前述产品技术的知识产品权利人，所涉著作权、商标权、专利权、商业秘密等知识产权以及与本网站或技术产品相关的各类信息内容均受法律保护。未经动态时序及相关权利人同意，任何主体不得抓取本网站信息、数据、不得复制、抄袭本网站或进行商业化使用，也不得进行反向工程、反向编译、反汇编等。</p>
		<p>6.2.当用户使用动态时序的技术产品时，动态时序给予用户一项不可转让及非排他性的使用许可，未经动态时序或相关权利人书面同意，用户不得自行转让授权或许可第三方使用，实施上述知识产权。</p>
		<p>6.3.如果您是企业用户，您同意我们以宣传推广的目的在官网或其他宣传材料中使用您的名称、字号、商标等信息标识，表明您是我们的合作伙伴。</p>
		<h5>7.保密责任</h5>
		<p>7.1.用户因同意或履行本协议，或因使用动态时序提供的产品服务而获得的有关动态时序的任何非公开信息，包括但不限于技术文档、源代码、合作协议、商务计划书、产品订单信息等均视为动态时序的商业秘密，用户承诺予以严格保密。除用于使用本服务之目的，不得自行使用或允许他人使用，亦不得向任何第三方披露。本款下的保密义务不因合作的中止或终止而终止。</p>
		<p>7.2.如用户违反保密约定，应自行承担因此引起的一切不利后果，并赔偿动态时序及其关联公司因此受到的损失。
		<h5>8.违约责任</h5>
		<p>8.1.如因动态时序违反有关法律、法规或本协议项下义务而给用户造成损失，动态时序同意承担相应的损害赔偿责任，并向用户赔偿用户的直接损失。</p>
		<p>8.2.如因用户违反有关法律、法规或本协议及相关协议的约定而给动态时序或任何其他第三方造成的全部损失，用户应独立承担赔偿责任（包括但不限于依法必须支付给第三方的赔偿款、诉讼费、律师费、公证费等）。</p>
		<p>8.3.用户理解并同意，如由于用户的原因导致第三方要求动态时序及其关联公司承担责任的，动态时序及其关联公司有权独立判定是否和解、和解的方式与金额等。前述情形下，和解金额亦为动态时序及其关联公司的损失，由用户全额承担，同时用户在此授权动态时序及其关联公司自用户的动态时序账户中径行划扣部分款项。</p>
		<h5>9.免责申明</h5>
		<p>本免责申明规定了动态时序特定情形下不承担责任的内容，与用户权益息息相关，用户应仔细、逐项阅读。若用户不同意本免责申明的内容，应停止注册或停止使用动态时序服务并注销动态时序账户。用户完成注册程序并使用动态时序的服务，视为用户已经完全知悉、理解本免责申明对其权利、义务、责任的特别约定，并同意接受该等约定，豁免动态时序对的相应责任。</p>
		<p>1）动态时序可能会对产品使用情况进行统计。同时，动态时序可能会与公众分享这些统计信息，以展示动态时序服务的整体使用趋势。这些统计信息不包含用户的任何身份识别信息。</p>
		<p>2）除本服务条款另有规定或动态时序与您就某一具体产品服务另有约定外，在任何情况下，您同意动态时序对本服务条款所承担的赔偿责任总额不超过向您收取的当次服务费用总额。</p>
		<p>3）动态时序对于与本服务条款有关或由本服务条款引起的任何间接对的、惩罚性的、特殊性的、派生的损失（包括业务损失、收益损失、利润损失、使用数据、商誉或其他经济利益的是损失），不论是如何产生的，也不论是对本服务条款的违约（包括违反保证）还是由侵权造成的，仅在法律法规所规定应由动态时序承担的范围内承担责任。</p>
		<p>4）若由于第三方原因（包括但不限于第三方盗用账户、破坏计算机新系统、应用软件的终端用户误操作等）而产生升的纠纷或损失，均与动态时序无关；在此情形下，动态时序可以协助配合用户查明原因以妥善解决，但不视为任何保证、承诺、应允。</p>
		<p>5）非因动态时序的过错而引起的任何损失，动态时序不承担责任。</p>
		<h5>10.服务条款的变更</h5>
		<p>动态时序有权视需要对服务条款内容作出补充、删除或变更（以下统称“服务条款变更”），并有权通过消息推送、网页公告等方式在本网站相应位置进行公布，而无需另行单独通知用户。若用户不接受服务条款变更，可随时停止使用动态时序提供的服务。若用户在服务条款变更公示后仍继续使用动态时序提供的服务，则视为用户已经阅读并接受服务条款变更，并愿意受变更后服务协议条款的约束。</p>
		<h5>11.法律适用及争议解决</h5>
		<p>本协议的效力、履行和解释均适用中华人民共和国法律。若用户因本协议相关内容与动态时序产生争议，双方可协商解决。协商无法解决的，任何一方均有权向北京市海淀区仲裁委提起诉讼。</p>
		<h5>12.其他规定</h5>
		<p>12.1.如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。</p>
		<p>12.2.本协议中的标题仅为方便阅读而设，不应影响对本协议条款的理解。</p>
		<p>12.3.隐私保护：保护用户隐私和其他个人信息是动态时序的一项基本政策，具体内容详见动态时序相关隐私政策。</p>
		<p>12.4.鉴于有关法律法规正在持续不断的完善，如相关法律规定与本协议有冲突之处，以相关法律规定为准。</p>
		<router-view></router-view>
    </article>
</template>
<script>
export default {
    namme:'case1',
    data(){
        return{
            
        }
    },
    methods:{
       
    },
    mounted(){
       this.$store.commit('setAboutIndex',1)
    }
}
</script>
<style lang="less" scoped>
	/* 协议正文排版：handoff 文档样式（标题层级 + 正文行高），正文内容未做任何改动 */
	.doc-article {
		padding: 38px 44px 10px;
		background: #fff;
		border: 1px solid #E8EBF0;
		border-radius: 14px;
		h5 {
			font-size: 17px;
			font-weight: 700;
			color: #111827;
			margin: 26px 0 10px;
		}
		p {
			font-size: 14.5px;
			line-height: 1.9;
			color: #374151;
			margin-bottom: 10px;
		}
		a {
			color: #1A56DB;
			word-break: break-all;
		}
		a:hover {
			text-decoration: underline;
		}
	}
	@media (max-width: 620px) {
		.doc-article {
			padding: 24px 20px 4px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/aboutUs/caseChild/case2.vue